<template lang="pug">
.mobile-list(v-bind:style="{top: (isNavClick ? '50px' : '-100%')}")
  ul
    li
      a(href='/') 首页
    li
      a(href='/intro') 项目介绍
    li
      a(href='/news') 前沿动态
    li
      a(href='/entry') 会员申请
    //- li
      a(href='/observer') 观察员申请
    li
      a(href='/about') 关于我们
    li
      a(href='/volunteers') 志愿者招募
</template>

<script>
export default {
  name: 'mobile-nav',
  computed: {
    isNavClick () {
      return this.$store.state.isNavClick
    }
  },
  methods: {
    navClick: function () {
      this.$store.commit('navClick')
    }
  }
}
</script>

<style lang="stylus">
@import '../../assets/css/var'

.mobile-list
  display none

@media $media
  .mobile-list
    display block
    width 100%
    height 100%
    position fixed
    top 0px
    z-index 10
    background rgba(30, 30, 30, 0.98)
    transition top 0.5s

    .mobile-nav
      height 44px
      width 100%
      font-size 2.1rem
      font-family 'FZLTTHCJW--GB1-0'

      .title
        text-align center
        line-height 44px

      .close
        width 24px
        position absolute
        right 15px
        top 10px

    ul
      width inherit
      height calc(100% - 100px)
      overflow-y scroll

      li:nth-child(1)
        margin-top 50px
    ul
      li
        margin 0 20px
        text-align center
        line-height 1.5em
        border-bottom 1px solid #999
        a
          display inline-block
          width 100%
          color #ffffff
          font-size 16px
          line-height 3em
          transition all 0.5s

      .english-down
        vertical-align middle
        height 1.1em
        margin 0 2px

</style>



// WEBPACK FOOTER //
// Nav.vue?2dd2859c